import { CurrencyFormats } from '../contracts/types';
var CURRENCY_CODES;
(function (CURRENCY_CODES) {
    CURRENCY_CODES["GBP"] = "GBP";
    CURRENCY_CODES["FKP"] = "FKP";
})(CURRENCY_CODES || (CURRENCY_CODES = {}));
export function formatMoney(cultureCode, currencyCode, format, cost) {
    if (cost === undefined) {
        return '';
    }
    const mCurrencyCode = currencyCode === CURRENCY_CODES.FKP ? CURRENCY_CODES.GBP : currencyCode;
    switch (format) {
        case CurrencyFormats.Rounded:
            return Intl.NumberFormat(cultureCode, {
                style: 'currency',
                currency: mCurrencyCode,
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
            }).format(cost);
        case CurrencyFormats.Formatted:
            return Intl.NumberFormat(cultureCode, {
                style: 'currency',
                currency: mCurrencyCode,
            }).format(cost);
        default:
            return String(cost);
    }
}
export function formatToParts(cultureCode, currencyCode, isRounded, cost, includeSign = false) {
    if (cost === undefined) {
        return [];
    }
    const mCurrencyCode = currencyCode === CURRENCY_CODES.FKP ? CURRENCY_CODES.GBP : currencyCode;
    const numberFormat = new Intl.NumberFormat(cultureCode, {
        style: 'currency',
        currency: mCurrencyCode,
        maximumFractionDigits: isRounded ? 0 : undefined,
        minimumFractionDigits: isRounded ? 0 : undefined,
        signDisplay: includeSign ? 'always' : 'auto',
    });
    return numberFormat.formatToParts(cost);
}
export function toMoney(value, cultureCode = 'en-gb', currencyCode = 'GBP', isRounded = false, includeSign = false) {
    if (value !== undefined) {
        return {
            formatted: formatMoney(cultureCode, currencyCode, isRounded ? CurrencyFormats.Rounded : CurrencyFormats.Formatted, value !== null && value !== void 0 ? value : undefined),
            parts: formatToParts(cultureCode, currencyCode, isRounded, value !== null && value !== void 0 ? value : undefined, includeSign),
            value,
        };
    }
    return null;
}
